export const SCREEN_L_SIZE = 1024;
